import { SVGProps } from 'react';

export default function Businesses(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 13.951V0h16.634v16.634H0V13.95zm13.951 0V2.683H2.683V13.95H13.95z"
        fill="currentColor"
        fillOpacity={0.3}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.317 5.367H5.366V22H22V5.367h-2.683zm0 2.682H8.05v11.269h11.268V8.049z"
        fill="currentColor"
      />
      <path
        fill="#EBF4FF"
        d="M13.952 5.367h2.683V8.05h-2.683zM5.366 13.951h2.683v2.683H5.366z"
      />
    </svg>
  );
}
